import { ArrowLeftIcon } from "@phosphor-icons/react";

import { Button } from "ui2";

export const SubScreenHeader = ({
  meetingName,
  onBack,
}: {
  meetingName: string;
  onBack: () => void;
}): React.JSX.Element => (
  <div className="tw:flex tw:items-center tw:gap-2 tw:border-b tw:border-stroke tw:px-3 tw:py-3">
    <Button size="icon" variant="ghost" aria-label="Back" onClick={onBack}>
      <ArrowLeftIcon size={22} />
    </Button>
    <div className="tw:font-medium tw:text-midnight">{meetingName}</div>
  </div>
);
